var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.668 0.667969H15.668C15.1157 0.667969 14.668 1.11568 14.668 1.66797V10.3346C14.668 10.8869 15.1157 11.3346 15.668 11.3346H16.668C17.2203 11.3346 17.668 10.8869 17.668 10.3346V1.66797C17.668 1.11568 17.2203 0.667969 16.668 0.667969ZM11.0013 3.0013H12.0013C12.5536 3.0013 13.0013 3.44902 13.0013 4.0013V10.3346C13.0013 10.8869 12.5536 11.3346 12.0013 11.3346H11.0013C10.449 11.3346 10.0013 10.8869 10.0013 10.3346V4.0013C10.0013 3.44902 10.449 3.0013 11.0013 3.0013ZM7.33464 5.33464H6.33464C5.78235 5.33464 5.33464 5.78235 5.33464 6.33464V10.3346C5.33464 10.8869 5.78235 11.3346 6.33464 11.3346H7.33464C7.88692 11.3346 8.33464 10.8869 8.33464 10.3346V6.33464C8.33464 5.78235 7.88692 5.33464 7.33464 5.33464ZM2.66797 7.33464H1.66797C1.11568 7.33464 0.667969 7.78235 0.667969 8.33464V10.3346C0.667969 10.8869 1.11568 11.3346 1.66797 11.3346H2.66797C3.22025 11.3346 3.66797 10.8869 3.66797 10.3346V8.33464C3.66797 7.78235 3.22025 7.33464 2.66797 7.33464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.469bc8c74ef774a41e0599f70dc4aa7e.svg";
export { ForwardRef as ReactComponent };